import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import * as api from '@src/service/top-up'
import { CreateTransaction, TopUpPackage, SendTransaction } from '@src/types/top-up'

const initialState: {
  topUpPackages: TopUpPackage[]
  userCredits: number
  isTopUpModalOpen: boolean
} = {
  topUpPackages: [],
  userCredits: 0,
  isTopUpModalOpen: false,
}

const account = createSlice({
  name: 'account',
  initialState,
  reducers: {
    toggleTopUpModal(state, action: { payload: boolean }) {
      state.isTopUpModalOpen = action.payload
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTopUpPackages.fulfilled, (state, action) => {
        state.topUpPackages = action.payload
      })
      .addCase(fetchUserCredits.fulfilled, (state, action) => {
        state.userCredits = action.payload
      })
  },
})

export const sendTransaction = createAsyncThunk(
  'topUp/sendTransaction',
  async (data: SendTransaction) => {
    const response = await api.sendTransaction(data)
    return response
  },
)

export const createTransaction = createAsyncThunk(
  'topUp/CreateTransaction',
  async (data: CreateTransaction) => {
    const response = await api.createTransaction(data)
    return response
  },
)

export const createPaymentTransaction = createAsyncThunk(
  'topUp/createPaymentTransaction',
  async (id: number) => {
    const response = await api.createPaymentTransaction(id)
    return response
  },
)

export const fetchTopUpPackages = createAsyncThunk('topUp/fetchTopUpPackages', async () => {
  const { data } = await api.getTopUpPackages()
  return data
})

export const fetchUserCredits = createAsyncThunk('topUp/fetchUserCredits', async () => {
  const { data } = await api.getUserCredits()
  return data
})

export const { toggleTopUpModal } = account.actions

export default account.reducer
